export const config = {
  rowSelection: false,
  columns: [
    {
      title: '需求标签',
      dataIndex: 'bizOpTypeName',
      width: 200,
      name: 'bizOpTypeName',
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '品牌',
      dataIndex: 'brandName',
      width: 200,
      name: 'brandName',
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '地理位置',
      dataIndex: 'regionName',
      width: 200,
      name: 'regionName',
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '门店名称',
      dataIndex: 'companyName',
      width: 200,
      name: 'companyName',
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '创建时间',
      dataIndex: 'createdTime',
      name: 'createdTime',
      width: 180,
      itemType: 'dateTime',
    },
    {
      title: '操作',
      key: 'action',
      width: 140,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      label: '城市',
      name: 'cityCode',
      itemType: 'select',
      labelKey: 'regionName',
      key: 'regionCode',
      data: 'regionList',
    },
    {
      label: '门店',
      name: 'storeId',
      itemType: 'select',
      labelKey: 'name',
      key: 'id',
      data: 'companyList',
    },
    {
      label: '需求标签',
      name: 'bizType',
      itemType: 'select',
      labelKey: 'description',
      key: 'key',
      data: 'BizOpTypeEnumList',
    },
    {
      label: '品牌',
      name: 'brandId',
      itemType: 'select',
      labelKey: 'brandName',
      key: 'id',
      data: 'brandList',
    },
  ],
  footer: [
    {
      label: '新增',
      type: 'primary',
      events: ['onClick:onAdd'],
    },
  ],
}
